import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIEndpoints } from "src/config/apiEndpoint.config";
import { HttpService } from "../http.service";
import { Area } from "../Models/read";

@Injectable({
  providedIn: "root",
})
export class AreaService {
  constructor(private readonly httpService: HttpService) {}

  getCityNames(): Observable<string[]> {
    return this.httpService.get(APIEndpoints.getAdressFilterList);
  }

  getFiberHoodsForCityName(cityName: string): Observable<Area[]> {
    return this.httpService.get(
      APIEndpoints.surveyListFiberHoodFilter + cityName
    );
  }

  getBlocksForFiberHoodId(fiberHoodId: string): Observable<Area[]> {
    return this.httpService.get(APIEndpoints.getAreasByParentId + fiberHoodId);
  }
}
